import { postRequest } from "../config/AxiosConfig";
import API_URLS from "../config/BackendConfig";
import { getAuthToken } from "../utils/tokenUtils";

export const fetchCustomerData = async (params) => {
  try {
    const token = getAuthToken();
    //console.log(params);
    const response = await postRequest({
      url: API_URLS.ADMIN + "customers",
      data: params,
      headers: { Authorization: `Bearer ${token}` },
    });
//console.log(response);
    return response;
  } catch (error) {
    console.error("Error fetching customer data:", error);
    return { error: error.message || "An unexpected error occurred." };
  }
};

// Edit Customer Details Service
export const editCusDetails = async ({ user_id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + "edit/customer",
      data: { user_id },
      headers: { Authorization: `Bearer ${token}` },
    });
  //  console.log("res",response);
    return response;
  } catch (error) {
    console.error("Error fetching customer details:", error);
    throw error;
  }
};

// Update Customer Details Service
export const updateCustomerDetails = async ({  payload, id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}update/customer/${id}`,
      data: payload, 
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

// ENd 



export const fetchAssignedServiceData = async (params) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + "service-details/userid",
      data: params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error("Error fetching Assigned Service data:", error);
    return { error: error.message || "An unexpected error occurred." };
  }
};


// Service Usage Report API
// All fields are optional: from_date, to_date, vendor_id, service_id, per_page
export const ServiceUsageService = async (params, page = 1) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + `services/usage-report?page=${page}`, // Fixed: removed "Usage" typo
      data: params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error("Error fetching Service Usage data:", error);
    throw error;
  }
};


// Fetch Vendor Service List API
// Optional params: vendor_id, per_page
export const fetchVendorServiceUsage = async (params = {}) => {
  try {
    const token = getAuthToken();
    return await postRequest({
      url: `${API_URLS.ADMIN}vendor/service-list`,
      headers: { Authorization: `Bearer ${token}` },
      data: params  // Pass params instead of empty object
    });
  } catch (error) {
    console.error("Error fetching vendor service list:", error);
    throw error;
  }
};


// {
//     "from_date": "2025-10-01",
//     "to_date": "2025-10-31",
//     "vendor_id": 1,
//     "service_id": 1,
//     "per_page": 100
// }
// all are optional
export const ServiceRevenueService = async (params, page = 1) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + `services/revenue-report?page=${page}`,
      data: params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error("Error fetching Service data:", error);
    throw error;
  }
};